module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/teams/teams.component.css
// module id = ./src/app/teams/teams.component.css
// module chunks = main